import { GovernmentLevel } from "../../types/Implementer";

export const governmentLevels: {[level in GovernmentLevel]: string} = {
  FEDERAL: "Federal",
  STATE: "Estatal",
  MUNICIPAL: "Municipal"
};
